<template>
  <div class="tags">
    <tag-item :bg="colorId(index)" v-for="(tag, index) in tags" :key="tag">{{tag}}</tag-item>
  </div>
</template>

<script>
import TagItem from "@/components/portfolio/TagItem";
const COLORS_NUMBER = 3;

export default {
  name: "TagList",
  components: {TagItem},
  props: ['tags'],
  methods:{
    colorId(i){
      i = i % COLORS_NUMBER;
      return ++i;
    }
  }
}
</script>

<style scoped>
.tags {
  display: flex;
  justify-content: start;
  flex-wrap: wrap;
}

</style>